import filters from '@/vue-utils/filters';
import { BigNumber as NS } from 'bignumber.js';
import { ItemCloseRecordSource } from '../../utils/itemClose';
var BinanceExecutionTypes;
(function (BinanceExecutionTypes) {
    BinanceExecutionTypes["new"] = "NEW";
    BinanceExecutionTypes["canceled"] = "CANCELED";
    BinanceExecutionTypes["calculated"] = "CALCULATED";
    BinanceExecutionTypes["expired"] = "EXPIRED";
    BinanceExecutionTypes["trade"] = "TRADE";
})(BinanceExecutionTypes || (BinanceExecutionTypes = {}));
var BinanceOrderTypes;
(function (BinanceOrderTypes) {
    BinanceOrderTypes["market"] = "MARKET";
    BinanceOrderTypes["limit"] = "LIMIT";
    BinanceOrderTypes["stopLoss"] = "STOP_LOSS_LIMIT";
    BinanceOrderTypes["takeProfit"] = "TAKE_PROFIT_LIMIT";
    BinanceOrderTypes["liquidation"] = "LIQUIDATION";
})(BinanceOrderTypes || (BinanceOrderTypes = {}));
var BinanceOrderStatuses;
(function (BinanceOrderStatuses) {
    BinanceOrderStatuses["new"] = "NEW";
    BinanceOrderStatuses["partiallyFilled"] = "PARTIALLY_FILLED";
    BinanceOrderStatuses["filled"] = "FILLED";
    BinanceOrderStatuses["canceled"] = "CANCELED";
    BinanceOrderStatuses["expired"] = "EXPIRED";
    BinanceOrderStatuses["newInsurance"] = "NEW_INSURANCE";
    BinanceOrderStatuses["newADL"] = "NEW_ADL";
})(BinanceOrderStatuses || (BinanceOrderStatuses = {}));
var BinanceTransferSides;
(function (BinanceTransferSides) {
    BinanceTransferSides["buy"] = "BUY";
    BinanceTransferSides["sell"] = "SELL";
})(BinanceTransferSides || (BinanceTransferSides = {}));
var Sections;
(function (Sections) {
    Sections["spot"] = "\u0421\u043F\u043E\u0442";
    Sections["futures"] = "\u0424\u044C\u044E\u0447\u0435\u0440\u0441";
})(Sections || (Sections = {}));
var TransferSides;
(function (TransferSides) {
    TransferSides["long"] = "\u041B\u043E\u043D\u0433";
    TransferSides["short"] = "\u0428\u043E\u0440\u0442";
    TransferSides["stopLoss"] = "SL";
    TransferSides["takeProfit"] = "TP";
})(TransferSides || (TransferSides = {}));
const getOrderDirection = (side) => {
    return side === BinanceTransferSides.buy ? TransferSides.long : TransferSides.short;
};
const isStopLossTakeProfitType = (type) => {
    const stopLossTakeProfitTypes = [
        BinanceOrderTypes.stopLoss,
        BinanceOrderTypes.takeProfit
    ];
    return stopLossTakeProfitTypes.includes(type);
};
function handleOrderUpdate(commit, getters, dispatch, data) {
    const d = data;
    const isStopLossTakeProfit = isStopLossTakeProfitType(d.o);
    if (d.X === BinanceOrderStatuses.new && d.x === BinanceExecutionTypes.new) {
        const body = {
            ticker: d.s,
            volume: NS(d.q).abs(),
            positionPrice: filters.formatToCurrency(isStopLossTakeProfit ? d.P : d.p, 'bnb'),
            direction: getOrderDirection(d.S),
            section: Sections.spot,
            id: d.i,
            closing: false
        };
        commit('pushItemInLimits', { data: body, getters });
    }
    if ((d.X === BinanceOrderStatuses.filled && d.x === BinanceExecutionTypes.trade) || (d.X === BinanceOrderStatuses.canceled && d.x === BinanceExecutionTypes.canceled)) {
        dispatch('setOrderClose', { by: ItemCloseRecordSource.binance, id: d.i });
    }
}
export function handleSpotOrderUpdate(commit, getters, dispatch, data) {
    handleOrderUpdate(commit, getters, dispatch, data);
}
export function handleSpotAccountBalanceUpdate(commit, data) {
    const changedAssets = data.B;
    if (Array.isArray(changedAssets)) {
        changedAssets.forEach((changedAsset) => {
            commit('changeDepositSpot', {
                asset: changedAsset.a,
                value: parseFloat(changedAsset.f)
            });
        });
    }
}
